const styles: Record<string, string> = {
  pending:              "bg-cream-dark text-ink-soft",
  moderating:           "bg-amber/30 text-ink",
  moderation_rejected:  "bg-coral/20 text-coral-dark",
  queued:               "bg-cream-dark text-ink-soft",
  submitted:            "bg-teal/20 text-teal",
  running:              "bg-teal/30 text-teal animate-pulse",
  completed:            "bg-coral/20 text-coral-dark",
  failed:               "bg-coral/30 text-coral-dark",
};

const labels: Record<string, string> = {
  pending: "queued",
  moderating: "checking",
  moderation_rejected: "rejected",
  queued: "queued",
  submitted: "submitted",
  running: "making it live",
  completed: "ready",
  failed: "failed",
};

export function StatusBadge({ status }: { status: string }) {
  return (
    <span className={`badge ${styles[status] ?? styles.pending}`}>
      <span className="size-1.5 rounded-full bg-current opacity-70" />
      {labels[status] ?? status}
    </span>
  );
}
